export enum LogoSize {
  ONE_X = "1x",
  TWO_X = "2x"
}

export enum LogoType {
  LOGO = "logo",
  ICON = "icon"
}
